
export default function NiMoon() {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M4.74986 16.7432C7.32279 21.292 13.0213 22.8505 17.4777 20.2242C18.7341 19.4838 19.7577 18.4898 20.5222 17.3421C20.7792 16.9563 20.3537 16.4958 19.9155 16.6286C16.5806 17.6392 12.8806 16.2318 11.0648 13.0216C9.2491 9.81153 9.90502 5.83713 12.4299 3.39441C12.7616 3.07348 12.5837 2.46713 12.1279 2.50139C10.7719 2.60332 9.41671 3.01112 8.16028 3.75155C3.70381 6.3778 2.17692 12.1943 4.74986 16.7432Z"
                stroke="currentColor"
                stroke-width="1.5"
            ></path>
            <path
                opacity="0.6"
                d="M12 18.5L11.5 18.5"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
            ></path>
            <path
                opacity="0.6"
                d="M9.5 16.5L8.5 16.5"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
            ></path>
        </svg>
    )
}
